export default {
	start: {
		title: "Piattaforma AI",
		tips: "Trasforma lo scrolling in guadagno! Prelievi giornalieri con un tocco - Il tuo telefono, la tua macchina per fare soldi!"
	},
	login: {
		tips: "Non hai un account?",
		Signup: "Registrati",
		logIn: "Accedi",
		Remember: "Ricordami",
		form: {
			label: ["Nome utente/Telefono", "Password"]
		},
		forgotPassword: "Password dimenticata?",
		contactSupport: "Contatta il supporto",
		title: "Crea un account",
		content: ["Hai bisogno di un account?", "Crea un account qui"]
	},
	register: {
		form: {
			label: [
				"Nome utente",
				"Telefono",
				"Password di transazione",
				"Password di accesso",
				"Conferma password di accesso",
				"Sesso",
				"Codice invito",
				"Email",
				"Codice di verifica"
			],
			rule: {
				Username: "Il nome utente deve essere lungo da 4 a 10 caratteri",
				Email: "Inserisci un'email valida",
				Phone: "Il numero di telefono deve contenere almeno 4 cifre",
				ConfirmLoginPassword: "Le password non corrispondono",
				TradingPassword: "La password di transazione deve contenere almeno 6 cifre",
				LoginPassword: "La password di accesso deve contenere almeno 6 cifre"
			}
		},
		sendMsg: "Codice inviato! Controlla i tuoi messaggi.",
		agree: ["Accetto {0}", "Informativa sulla privacy, MSA", "e", "Termini di servizio"],
		content: [
			"Crea il tuo account gratuito",
			"Hai già un account?",
			"Accedi qui",
			"Crea account",
			"Continuando accetti i nostri"
		]
	}
};
